import { useSelector } from 'react-redux'
import { Message } from '@weblite/ts-action/message'
import { RootState } from '$setup/redux'
import { RoomLastMessage } from '$logic/room-last-message/types'
import { initiateRoomLastMessage } from '$logic/room-last-message/service'

const getRoomsLastMessageView = (
  state: RootState,
): Record<string, RoomLastMessage> => state.main.roomLastMessage

const getRoomLastMessageView = (roomId: string) => (state: RootState) =>
  state.main.roomLastMessage?.[roomId] as RoomLastMessage

export function useRoomsLastMessage() {
  return useSelector(getRoomsLastMessageView)
}

export function useRoomLastMessageSync(roomId: string) {
  return useSelector(getRoomLastMessageView(roomId))
}

export function useRoomLastMessage(roomId: string = ''): Message | undefined {
  const roomLastMessage = useSelector(getRoomLastMessageView(roomId))
  if (!roomLastMessage) {
    initiateRoomLastMessage(roomId)
  }
  return roomLastMessage?.lastMessage?.patches?.deleted
    ? undefined
    : roomLastMessage?.lastMessage
}
